import { Button, Popover, Stack, Typography } from '@mui/material';
import { useEffect, useRef, useState } from 'react';

import { isValueCondition } from '@/types/advanceFilter';

import { TagsCondition } from './tagsCondition';
import type { TagsFilterProps } from './tagsFilter';

type TagsConditionSelectorProps = Omit<
  TagsFilterProps,
  'allowChangingFilterMode' | 'onDoneClick' | 'panelTitle'
>;

export const TagsConditionSelector = (props: TagsConditionSelectorProps) => {
  const anchorRef = useRef<HTMLButtonElement>(null);
  const [popoverOpen, setPopoverOpen] = useState(props.popoverOpen || false);

  useEffect(() => {
    if (props.popoverOpen !== undefined) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setPopoverOpen(props.popoverOpen);
    }
  }, [props.popoverOpen]);

  const condition = props.conditions.find(
    (x) => isValueCondition(x) && x.property === props.property.name
  );

  const selectedTags = (isValueCondition(condition) && condition?.value) || [];

  return (
    <>
      {!props.hideButton && (
        <Button
          ref={anchorRef}
          onClick={() => setPopoverOpen(true)}
          disableFocusRipple
          size='small'
          className='px-0 py-[5px]'
        >
          <Stack
            direction={'row-reverse'}
            gap='8px'
            className='pl-[12px] pr-[8px]'
          >
            <i className='material-symbols-arrow-drop-down-rounded text-xl align-middle min-w-[22px] min-h-[22px] w-[22px] h-[22px]' />
            {selectedTags.length === 0 && (
              <Typography
                variant='button'
                color='var(--mui-palette-text-disabled)'
                className='text-left font-medium'
              >
                Select
              </Typography>
            )}
            {selectedTags.length > 0 && (
              <Typography
                variant='button'
                color='currentcolor'
                className='text-left font-medium'
              >
                {selectedTags.join(', ')}
              </Typography>
            )}
          </Stack>
        </Button>
      )}
      <TagsConditionPanelPopover
        {...props}
        anchorRef={props.anchorRef || anchorRef}
        popoverOpen={popoverOpen}
        selectedTags={selectedTags}
        onChange={props.onChange}
        onClose={() => {
          setPopoverOpen(false);
          props.onClose?.();
        }}
      />
    </>
  );
};

interface TagsConditionPanelPopoverProps extends TagsConditionSelectorProps {
  anchorRef: React.RefObject<HTMLElement | null>;
  popoverOpen: boolean;
  selectedTags: string[];
  onClose: () => void;
}

const TagsConditionPanelPopover = (props: TagsConditionPanelPopoverProps) => {
  return (
    <Popover
      open={props.popoverOpen}
      anchorEl={props.anchorRef.current}
      onClose={() => props.onClose()}
    >
      <Stack className='w-[308px]'>
        <TagsCondition
          {...props}
          conditions={[...props.conditions]}
          onChange={props.onChange}
          onDoneClick={() => props.onClose()}
        />
      </Stack>
    </Popover>
  );
};
